export default __webpack_public_path__ + "static/media/(9).c524ab43.jpg";